var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.show)?_c('el-row',{staticClass:"headerWrapper",staticStyle:{"background-color":"#f5f7fa !important"}},[_c('heard')],1):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"min-height":"800px"}},[_c('router-view',{on:{"header":_vm.header}})],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"0","margin":"0"}},[_c('footers')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-997cfb3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 